/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { IIframeModuleData } from './iframe-module.data';
import { IIframeModuleProps } from './iframe-module.props.autogenerated';

/**
 *
 * IframeModule component
 * @extends {React.PureComponent<IIframeModuleProps<IIframeModuleData>>}
 */
class IframeModule extends React.PureComponent<IIframeModuleProps<IIframeModuleData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        if(!config.href) {
            return null;
        }
        return (
            <div className={config.className && config.className !== '' ? config.className : 'iframe-module'}>
                {/* tslint:disable-next-line: react-iframe-missing-sandbox */}
                <iframe
                    className={config.className && config.className !== '' ? `${config.className}-content` : 'iframe-module-content'}
                    src={config.href}
                    width={config.width}
                    height={config.height}
                />
            </div>
        );
    }
}

export default IframeModule;
